import { EMBED_MESSAGE_MIN_SIZE } from "~/feature/embed/constants";
import type { IEmbedSize } from "~/feature/embed/utils/getEmbedMinSize";

export const getEmbedMessageSize = (size: IEmbedSize): IEmbedSize => ({
  width: Math.max(EMBED_MESSAGE_MIN_SIZE.width, size.width),
  height: Math.max(EMBED_MESSAGE_MIN_SIZE.height, size.height),
});
